var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sys-select-base',{attrs:{"model":_vm.selected,"items":_vm.items,"loading":_vm.loading,"label":_vm.label,"error":_vm.error,"errors":_vm.errors,"showAdd":_vm.showAdd,"disabled":_vm.disabled,"dense":_vm.dense},on:{"update:model":function($event){_vm.selected=$event},"onShowForm":function($event){_vm.showForm = true}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }